import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule, DateAdapter, TimeAdapter, ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NgbNavModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbDateAdapter,
  NgbTimeAdapter,
} from '@ng-bootstrap/ng-bootstrap';
import { WhatsAppContactDetailViewService } from '../services/whats-app-contact-detail.service';
import { GetWhatsAppContactsInput, WhatsAppContactService } from '@proxy/whats-app-contacts';
import { WhatsAppContactViewService } from '../services/whats-app-contact.service';
import { PageModule } from '@abp/ng.components/page';

@Component({
  selector: 'app-whats-app-contact-detail-modal',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbNavModule,
    PageModule,
  ],
  providers: [
    WhatsAppContactViewService,
    WhatsAppContactDetailViewService,
    { provide: NgbDateAdapter, useClass: DateAdapter },
    { provide: NgbTimeAdapter, useClass: TimeAdapter },
  ],
  templateUrl: './whats-app-contact-detail.component.html',
  styles: [],
})
export class WhatsAppContactDetailComponent implements OnInit {
  public readonly service_geral = inject(WhatsAppContactViewService);
  public readonly service = inject(WhatsAppContactDetailViewService);
  public readonly proxyService = inject(WhatsAppContactService);
  private readonly confirmationService = inject(ConfirmationService)

  input: GetWhatsAppContactsInput = { maxResultCount: 1 }

  loaded = false

  private readonly options: Partial<Confirmation.Options> = {
        hideCancelBtn: true,
        hideYesBtn: false,
        dismissible: true,
        yesText: "Fechar",
      };

  getContacts() {
    this.proxyService.getList(this.input).subscribe((list) => {
      this.service.selected = list.items[0];
      this.service.showForm();

      this.loaded = true
      this.cdRef.detectChanges()
    });
  }

  submitForm() {
    if (this.service.form.invalid) return;
  
    const formValues = {
      ...this.service.form.value,
    };
  
    this.proxyService.update(this.service.selected.id, {
      ...formValues,
      concurrencyStamp: this.service.selected.concurrencyStamp,
    }).subscribe({
      next: () => {
        this.confirmationService.success("Dados de contato salvos com sucesso!", "Salvar", this.options);
        this.getContacts();
      },
      error: (error) => {
        console.error('Erro ao atualizar contato:', error);
        this.confirmationService.error('Ocorreu um erro ao salvar os dados do contato',
          'Erro',
          this.options
        );
      }
    }); 
  }

  constructor(private cdRef: ChangeDetectorRef) {
    this.service.buildForm()
  }

  ngOnInit() {
    this.getContacts()
  }
}
